var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0664 36.1333L37.4581 30.0417C36.5748 27.975 34.9498 27.8917 33.8581 29.8583L32.2831 32.7C31.4831 34.1417 29.9914 34.2667 28.9581 32.975L28.7748 32.7417C27.6998 31.3917 26.1831 31.5583 25.4081 33.1L23.9748 35.975C22.9664 37.975 24.4248 40.3333 26.6581 40.3333H37.2914C39.4581 40.3333 40.9164 38.125 40.0664 36.1333Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8081 28.6667C29.1888 28.6667 30.3081 27.5474 30.3081 26.1667C30.3081 24.786 29.1888 23.6667 27.8081 23.6667C26.4274 23.6667 25.3081 24.786 25.3081 26.1667C25.3081 27.5474 26.4274 28.6667 27.8081 28.6667Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbPlaceholder);
export default __webpack_public_path__ + "static/media/thumb-placeholder.64f2cada8f7c65aba22a273812aecec4.svg";
export { ForwardRef as ReactComponent };